export default {
  props: {
    // 地址
    address: {
      default: ""
    }
  },
  data() {
    return {
      query: {
        keyword: ""
      },
      page: 1,
      pageSize: 10,
      data: [],
      listData: []
    };
  },
  watch: {
    // address: {
    //   immediate: true,
    //   handler(val) {
    //     console.log(this.initCfg.listApi)
    //     if (!this.initCfg.listApi) return;
    //     this.query.keyword = val;
    //     this.search();
    //   }
    // }
  },
  methods: {
    // 列表数据
    search(address) {
      this.page = 1;
      this.query.keyword = address;
      this.getListData();
    },

    getListData() {
      let { listApi } = this.initCfg;
      const param = {
        ...this.query,
        page: this.page,
        size: this.pageSize
      };

      this.$request[listApi](param).then(res => {
        this.listData = this.uploadList(res.list.list);
        this.total = res.list.totalRow;

        this.$emit("on-update-list", this.listData);
      });
    },

    // 翻页
    changePage(page) {
      this.page = page;
      this.getListData();
    },

    getCurrListData() {
      return this.listData;
    }
  }
};
